import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { NoIndex } from '@sorare/core/src/contexts/seo';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import { createCardSorts } from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/football';

import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { leaguePageFilters } from '@sorare/marketplace/src/searchCards/football/cardFilters';

import { FootballCardSearch } from 'components/searchCards/FootballCardSearch';
import { useLayoutData } from 'pages/leagues/$slug/layout';

const cardSortsWithBestValue = createCardSorts({
  withBestValue: true,
  withHighestAverageScore: true,
  withPopularPlayer: true,
});

const Cards = () => {
  const competition = useLayoutData();
  const filters = useDefaultFilters({
    leagueSlug: competition.slug,
    excludePrimaryOffers: true,
  });

  useTitleAndDescription(
    metadatas.leagueCards.title,
    metadatas.leagueCards.description,
    {
      league: competition.name,
    }
  );

  return (
    <FullWidthContainer>
      <NoIndex />
      <FootballCardSearch
        analyticsTags={['League', 'Football']}
        defaultFilters={filters}
        cardFilters={leaguePageFilters}
        sorts={cardSortsWithBestValue}
        defaultSort="Newly Listed"
        topic={{ type: 'league', label: competition.name }}
      />
    </FullWidthContainer>
  );
};

export default Cards;
